var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLineChart = function SvgLineChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_1421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28564 1.28577V19.0638C1.28564 20.8718 2.68802 22.3682 4.49379 22.4599C6.73155 22.5736 9.71422 22.6986 11.9999 22.6986C16.1875 22.6986 22.7142 22.2787 22.7142 22.2787M5.99993 13.4843C5.99993 13.4843 9.32796 16.3888 10.2856 15.8415C12.1462 14.7783 14.1428 2.98435 16.0714 2.98435C17.6785 2.98435 22.2856 8.34149 22.2856 8.34149",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_1421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export { SvgLineChart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3Ml8xNDIxKSI+CjxwYXRoIGQ9Ik0xLjI4NTY0IDEuMjg1NzdWMTkuMDYzOEMxLjI4NTY0IDIwLjg3MTggMi42ODgwMiAyMi4zNjgyIDQuNDkzNzkgMjIuNDU5OUM2LjczMTU1IDIyLjU3MzYgOS43MTQyMiAyMi42OTg2IDExLjk5OTkgMjIuNjk4NkMxNi4xODc1IDIyLjY5ODYgMjIuNzE0MiAyMi4yNzg3IDIyLjcxNDIgMjIuMjc4N001Ljk5OTkzIDEzLjQ4NDNDNS45OTk5MyAxMy40ODQzIDkuMzI3OTYgMTYuMzg4OCAxMC4yODU2IDE1Ljg0MTVDMTIuMTQ2MiAxNC43NzgzIDE0LjE0MjggMi45ODQzNSAxNi4wNzE0IDIuOTg0MzVDMTcuNjc4NSAyLjk4NDM1IDIyLjI4NTYgOC4zNDE0OSAyMi4yODU2IDguMzQxNDkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjcyXzE0MjEiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";